import { Component, Input, Output } from '@angular/core';

import { DocumentService } from './../../../../shared/index';
//import { CatalogService } from "./../../index";

@Component({
    selector: 'document-filter',
    templateUrl: './document-filter.html',
    standalone: false
})

export class DocumentFilterComponent {
    @Input('forAssociation') association = false;
    public filename = '';

    constructor(
        private _documentService: DocumentService,
        //private _catalogService: CatalogService
    ) { }

    public clear(): void {
        this.filename = '';
        this.search();
    }

    public search(): void {
        if (this.association) {
            this._documentService.search(this.filename);
        } else {
            this._documentService.searchFileName = this.filename;
            this._documentService.getDocuments(1);
        }
    }
    //public isInRole(component: string): boolean {
    //    return this._authorizationService.hasRole(component);
    //}
}
